<template>
  <li
    @click="() => onMainCategoryItemClick({item: category, link: formattedCategoryLink})"
    class="text-[16px] group sm:hover:text-primary/80 transition-all duration-200 cursor-pointer group p-0 m-0"
    aria-expanded="false"
    tabindex="0"
  >
    <button
      type="button"
      :aria-label="`open ${category[nameKey]} category `"
      :aria-labelledby="`open ${category[nameKey]} category`"
      :class="`${isActive ? 'text-primary font-bold': 'text-[#46474a] font-[400]'} border-b-[#e3e4e5] py-4 px-0 gap-2 w-full group-last:border-b-0 border-b-[.0625rem] flex`"
    >
      <!-- category title -->
      <span
        class="flex-1 rtl:text-right ltr:text-left"
      >{{category[nameKey]}}</span>
      <!-- next icon -->
      <span
        v-if="hasSubChildren"
        class="align-middle inline-block w-[24px] h-[24px] group-hover:text-black text-start border-0 bg-transparent focus:ring-0 focus:outline-0"
      >
        <svg
          class="rtl:rotate-180"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="m13.292 12l-4.6-4.6l.708-.708L14.708 12L9.4 17.308l-.708-.708l4.6-4.6Z"
          />
        </svg>
      </span>
      <span class="sr-only">{{category[nameKey]}}</span>
    </button>
  </li>
</template>

<script>
export default {
  data(){
    return {
      isActive: false,
    }
  },
  props: {
    getCurrentQueryObj: {
      type: Function,
      required: true
    },
    category: {
      type: Object,
      default: () => ({}),
      required: true
    },
    onMainCategoryItemClick: {
      type: Function,
      required: true
    }
  },
  computed: {
    formattedCategoryLink() {
      try{
        let queryToUrl = `${(this.item?.id !== "more" &&
        `&main_category_id=${this.item?.id}`) ||
        ""}${`&sort_by=date&sort_type=desc`}${`&from=list`}`.replace(/^&/, "");
        let encodedQuery = btoa(encodeURIComponent(queryToUrl));
        return `${this.ROUTESNAMES.user.products}?${encodedQuery}`;
      }catch{
        return `${this.ROUTESNAMES.user.products}`;
      }
      
    },
    hasSubChildren() {
      return this.category?.children?.length > 0;
    }
  },
  mounted(){
    this.isActive = this.getCurrentQueryObj()?.main_category_id == this.category?.id;
  }
};
</script>

<style>
</style>